import { downloadFile } from '@delmonicos/shared-sdk/libs/core/src/helpers/download-file';
import { getFilenameFromContentDisposition } from '@delmonicos/shared-sdk/libs/core/src/helpers/get-filename-from-response';
import { GatewayChargePointDiagnosticsModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-point-diagnostics/models/outputs/gateway-charge-point-diagnostics.model';

export const getDiagnosticFilename = (
  diagnostic: GatewayChargePointDiagnosticsModel,
  response: Response,
): string => {
  if (diagnostic.originalName) {
    return diagnostic.originalName;
  }

  const contentType = response.headers.get('content-type');

  return (
    getFilenameFromContentDisposition(response) ??
    `${diagnostic.id}-${diagnostic.createdAt}.${contentType ?? 'raw'}`
  );
};

export const downloadDiagnostic = async (
  diagnostic: GatewayChargePointDiagnosticsModel,
  response: Response,
): Promise<void> => {
  await downloadFile(response, getDiagnosticFilename(diagnostic, response));
};
